import React from "react";
import { Button } from "react-bootstrap";
import { useExportList } from "../../../apis/exportList/exportListProvider";

interface ExportListProps {
  filters: Record<string, string>;
}

const ExportList: React.FC<ExportListProps> = ({ filters }) => {
  const { exportList } = useExportList();

  const exportCSV = () => {
    exportList("csv", filters);
  };

  const exportPDF = () => {
    exportList("pdf", filters);
  };

  const exportExcel = () => {
    exportList("xlsx", filters);
  };

  return (
    <div className="mt-3 mb-3 d-flex gap-2">
      <Button variant="primary" onClick={exportCSV}>CSV</Button>
      <Button variant="danger" onClick={exportPDF}>PDF</Button>
      <Button variant="success" onClick={exportExcel}>Excel</Button>
    </div>
  );
};

export default ExportList;
